import React, { useEffect, useState } from 'react';
import { Portal } from '../portal/Portal';

import WpToastManager from './WpToastManager';
import WpToast from './WpToast';

import './WpToastContainer.scss';

const WpToastContainer: React.FC = () => {
  const [toasts, setToasts] = useState([]);

  const handleStoreChange = toastsIncoming => {
    setToasts(toastsIncoming);
  };

  useEffect(() => {
    WpToastManager.addChangeListener(handleStoreChange);
  }, []);

  const removeToast = toast => {
    WpToastManager.removeToast(toast);
  };

  const classNamePrefix = 'WpToastContainer';
  return (
    <Portal idPrefix="toast">
      <div className={classNamePrefix}>
        {toasts
          .sort(function (a, b) {
            return a.createdAt - b.createdAt;
          })
          .map(toast => (
            <WpToast key={toast.uuid} toast={toast} removeToast={removeToast} />
          ))}
      </div>
    </Portal>
  );
};

export default WpToastContainer;
